import request from '@/utils/request'
import { download } from '@/utils/request'
//根据业务id下载文件
export function getFileUrl(url, businessCode, fileName) {
    request({
        url: url + '/actuator/fileUpload/downLoad/' + businessCode,
        method: 'get',
    }).then(res => {
        if (res.data) {
            window.open(res.data.path)
        } else {
            window.open(url + "/actuator/fileDownload/localDownload?businessCode=" + businessCode)
        }
    })
}
//根据businessCode数组获取文件列表
export function getFileList(url, businessCodeAry) {
    return request({
        url: url + '/actuator/fileUpload/getFileList',
        method: 'post',
        data: businessCodeAry
    })
}

export function deleteFile(url, id) {
    return request({
        url: url + '/actuator/fileUpload/deleteFile',
        method: 'post',
        data: id
    })
}
//根据businessCode数组删除文件
export function deleteFiles(url, businessCodeAry) {
    return request({
        url: url + '/actuator/fileUpload/deleteFiles',
        method: 'post',
        data: businessCodeAry
    })
}

//获取赛事组
export function getDictData(url) {
    return request({
        url: url + '/dict/data/samsung/type',
        method: 'get'
    })
}
export function getDivisions(url) {
    return request({
        url: url + '/dict/data/type/sys_division',
        method: 'get'
    })
}

export function listUserAll(url,type) {
  return request({
    url: url+'/user/listAll/'+type,
    method: 'get'
  })
}

export function siteMess(url,query) {
  return request({
    url: url+'/actuator/site/'+query,
    method: 'get'
  })

}



// WEBPACK FOOTER //
// ./src/api/system/index.js